import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { ReactComponent as Illustration } from '../../assets/desktopIllustration.svg';
import { Confirm } from '../Confirm';

import styles from '../../styles/grid.module.scss';

const AddonsGridEmptyState = () => {
  const history = useHistory();
  const { t } = useTranslation('ShopAddons');

  return (
    <Confirm
      title={t('emptyState.title')}
      description={t('emptyState.description')}
      buttons={[
        {
          children: t('emptyState.goBackLabel'),
          onClick: () => {
            history.goBack();
          },
        },
      ]}
    >
      <Illustration className={styles['empty-state-illustration']} />
    </Confirm>
  );
};

export default AddonsGridEmptyState;
